import MainLayout from '../layouts/main';
import ExamReviewContainer from './container';

function ExamReviewPage() {
  return (
    <MainLayout title={EXAM_REVIEW_PAGE_TITLE}>
      <ExamReviewContainer />
    </MainLayout>
  );
}

export const EXAM_REVIEW_PAGE_TITLE = 'تحلیل آزمون';

export default ExamReviewPage;
